"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { signinGithub, signinGoogle } from "@/utils/auth-sign-in";
import { AICoalesce, AnonymousIcon, Button, Github, GoogleIcon, shimmer } from "@slipstream/ui";
export function AuthUI(t0) {
  const $ = _c(14);
  const {
    target: t1
  } = t0;
  const target = t1 === undefined ? "sign_in" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AICoalesce className="text-foreground stroke-foreground size-12" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = target === "sign_in" ? "Sign In" : "Sign Up";
  let t4;
  if ($[1] !== t3) {
    t4 = <h1 className="mt-8 text-2xl font-bold tracking-tight">{t3}</h1>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-muted-foreground mt-2 text-sm">Choose a provider to continue</p>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4) {
    t6 = <div className="select-none">{t2}{t4}{t5}</div>;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-8 grid grid-cols-1 gap-3"><Button variant="ghost" type="button" size="lg" onClick={signinGithub} className="dark:bg-background/50 text-foreground transition-color border-foreground/50 relative inline-flex w-full cursor-pointer items-center justify-center gap-3 rounded-md border px-4 py-2 text-sm font-semibold transition-colors duration-150 dark:hover:bg-transparent"><Github className="absolute inset-y-auto left-28 my-auto size-12" /><span className="absolute inset-y-auto left-36 my-auto">Continue with GitHub</span></Button></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mt-8 grid grid-cols-1 gap-3"><Button variant="ghost" type="button" size="lg" onClick={signinGoogle} className="dark:bg-background/50 text-foreground transition-color border-foreground/50 relative inline-flex w-full cursor-pointer items-center justify-center gap-3 rounded-md border px-10 py-2 text-sm font-semibold transition-colors duration-150 dark:hover:bg-transparent"><GoogleIcon className="absolute inset-y-auto left-28 my-auto size-12 rounded-full" /><span className="absolute inset-y-auto left-36 my-auto">Continue with Google</span></Button></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-8 hidden grid-cols-1 gap-3"><Button variant="ghost" type="button" size="lg" className="dark:bg-background/50 text-foreground transition-color border-foreground/50 relative inline-flex w-full cursor-pointer items-center justify-center gap-3 rounded-md border px-10 py-2 text-sm font-semibold transition-colors duration-150 dark:hover:bg-transparent"><AnonymousIcon className="absolute inset-y-auto left-28 my-auto size-12 rounded-full" /><span className="absolute inset-y-auto left-36 my-auto">Continue Anonymously</span></Button></div>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t6) {
    t10 = <div className="via-background/95 flex flex-1 items-center justify-center bg-linear-to-b from-gray-900 to-gray-900 px-6 py-12 sm:px-10 lg:px-20"><div className="w-full max-w-md">{t6}{t7}{t8}{t9}</div></div>;
    $[9] = t6;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="via-background/95 relative z-10 flex-1 bg-linear-to-b from-gray-900 to-gray-900 inset-shadow-gray-100 lg:block"><Image width={2160} height={1260} alt="aicoalesce" placeholder="blur" blurDataURL={shimmer([2160, 1260])} src="https://assets.aicoalesce.com/upload/nrr6h4r4480f6kviycyo1zhf/1759131668389-aicoalesce-og-final-1758955992844.png" className="absolute inset-0 my-auto w-full rounded-sm object-cover" /></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10) {
    t12 = <div className="text-foreground grid min-h-dvh grid-cols-1 bg-transparent lg:grid-cols-2">{t10}{t11}</div>;
    $[12] = t10;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  return t12;
}